import {
  mergeClasses,
  Skeleton,
  SkeletonItem,
} from "@fluentui/react-components";
import * as React from "react";
import type { Appearance } from "../../data";
import { useStyles } from "./PromptCardSkeleton.styles";

export const PromptCardSkeletonTestId = "prompt-card-skeleton";

export type PromptCardSkeletonProps = {
  appearance: Appearance;
  className?: string;
  isBadgesEnabled?: boolean;
  isFavoriteEnabled?: boolean;
};

export const PromptCardSkeleton: React.FC<PromptCardSkeletonProps> = ({
  appearance,
  className,
  isBadgesEnabled,
  isFavoriteEnabled,
}) => {
  const styles = useStyles(appearance)();
  const reducedHeight = !isFavoriteEnabled && !isBadgesEnabled;

  return (
    <Skeleton aria-label="Loading Content">
      <SkeletonItem
        className={mergeClasses(
          styles.card,
          className,
          reducedHeight && styles.shortCard
        )}
        data-testid={PromptCardSkeletonTestId}
      />
    </Skeleton>
  );
};
